// Foregrounds "Sanath Gamage Coaching" — BrainKey is the invisible platform
// vendor to these end-users, not the visible brand (unlike the coach portal,
// where BrainKey-the-tool is what the coach who bought it sees).
export function Logo({
  compact = false,
  inverted = false,
  light = false,
}: {
  compact?: boolean;
  /** Renders on the dark sidebar rail — swaps text colors and the mark's
   * cutout fill to blend with `--sidebar` instead of `--background`. Theme-
   * aware: `--sidebar`/`--sidebar-foreground` flip with light/dark mode. */
  inverted?: boolean;
  /** Always-white text on a fixed dark surface that does NOT follow the
   * light/dark theme toggle (the public marketing site's surface-ink footer,
   * P21-T02) — unlike `inverted`, which is theme-aware. */
  light?: boolean;
}): JSX.Element {
  const mark = (
    <svg width="32" height="32" viewBox="0 0 40 40" fill="none" aria-hidden="true">
      <circle cx="20" cy="20" r="20" className="fill-brand-500" />
      <circle
        cx="27"
        cy="13"
        r="7"
        className={light ? 'fill-surface-ink' : inverted ? 'fill-sidebar' : 'fill-background'}
      />
    </svg>
  );

  if (compact) return mark;

  const textClass = light ? 'text-white' : inverted ? 'text-sidebar-foreground' : 'text-foreground';
  const subTextClass = light
    ? 'text-white/60'
    : inverted
      ? 'text-sidebar-foreground/60'
      : 'text-muted-foreground';

  return (
    <div className="flex items-center gap-2.5">
      {mark}
      <span className={`font-display font-medium text-base leading-tight ${textClass}`}>
        Sanath Gamage
        <br />
        <span className={`text-xs font-sans font-normal tracking-wide ${subTextClass}`}>
          Coaching
        </span>
      </span>
    </div>
  );
}
